// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602101752/js/" + chunkId + "." + {"44":"941f7ce9","225":"c3151925","481":"6a844078","486":"a319dee2","770":"1eaff815"}[chunkId] + ".0.9733149926475342.chunk.js";
};